<script>
import EnergyReportForm from "@/components/energy-report-form.vue";
import UsageForm from "@/components/usage-form.vue";
import * as api from "@/services/api.js";

import demoCompanies from "@/assets/data/companies.json";

export default {
  name: "HomePage",
  components: {
    // ProductList,
    EnergyReportForm,
    UsageForm,
  },
  data: () => ({
    companies: demoCompanies,
    energyReportDialog: false,
    message: "",
    plantAddressFilter: null,
    plantHeaders: [
      {
        text: "Unit",
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: "Name",
        align: "start",
        sortable: true,
        value: "label",
      },
      {
        text: "Show",
        align: "start",
        sortable: true,
        value: "show",
      },
      // { text: 'Address', value: 'address' },
    ],
    showSelect: null,
    trailersLoading: false,
    trailerSearch: "",
    searchResults: null,
    usageDialog: false,
    tokenData: {},
  }),
  computed: {
    selectedTrailers: {
      get() {
        return this.$store.state.selectedTrailers;
      },

      set(v) {
        this.$store.dispatch("setSelectedTrailers", v);
      },
    },
    hiddenSelectedTrailers() {
      if (!this.selectedTrailers || !this.trailerSearch) {
        return 0;
      }

      let hiddenCount = 0;
      this.selectedTrailers.forEach((t) => {
        const trailerResult = this.searchResults.findIndex((r) => r.id == t.id);
        if (trailerResult < 0) {
          hiddenCount++;
        }
      });
      return hiddenCount;
    },
    trailers() {
      return this.$store.state?.activeAccountTrailers || [];
    },
    trailersShows() {
      const allShows = [...Object.values(this.trailerMap)].map(
        (p) => p?.show || ""
      );
      const shows = [...new Set(allShows)];
      return shows.sort((a, b) => a.localeCompare(b));
    },
    trailersDisplayed() {
      if (!this.trailers?.length) return [];
      let trailers = this.trailers.map((t) => {
        return {
          ...t,
          label: this.trailerMap?.[t.id]?.label || t?.name || "",
          show: this.trailerMap?.[t.id]?.show || "",
        };
      });

      if (this.showSelect !== null) {
        trailers = trailers.filter(
          (p) => this.trailerMap?.[p.id]?.show === this.showSelect
        );
      }
      return trailers;
    },
    trailerMap() {
      return this.$store.state?.trailerMap || {};
    },
  },
  methods: {
    async refreshAccountData() {
      console.log("refreshAccountData (account data, trailers, sessiondata)");
      this.isLoading = true;
      try {
        const resp = await api.get("sol/account-data");
        // console.log(resp)
        //TODO: DE-DUPLICATE CODE IN LOGIN COMP
        const { account, trailers, tokenData } = resp.data;
        this.$store.dispatch("setActiveAccount", account);
        this.$store.dispatch("setActiveAccountTrailers", trailers);
        console.log("TODO add to saved accounts");
        this.$store.dispatch("setActiveAccountSession", tokenData);

        // TOD DO.. SCROLL INTO TRAILERS?
        // if (trailers?.length) {
        //   console.log('has trtailers')
        //   await this.$nextTick()
        //   console.log(this.$refs.filterCard)
        //   this.$refs.filterCard?.$el?.scrollIntoView({ behavior: 'smooth' })
        // }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    // console.log('xxxxxxxxxxxx')
    // console.log(this.account)
    // await this.refreshAccountData()
  },
};
</script>
<template>
  <v-container fluid class="home-container pa-0">
    <v-card
      v-if="trailers?.length"
      ref="filterCard"
      color="primary"
      class="filter-card"
    >
      <v-card-text>
        <v-row justify="space-between">
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="trailerSearch"
              append-icon="mdi-magnify"
              clearable
              dark
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-autocomplete
              v-model="showSelect"
              clearable
              dark
              :items="trailersShows"
              label="Show"
              single-line
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            md="2"
            class="d-flex flex-column align-end justify-end"
          >
            <v-dialog v-model="usageDialog" max-width="400">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :block="$vuetify.breakpoint.xsOnly"
                  color="secondary"
                  :disabled="!selectedTrailers?.length"
                  v-bind="attrs"
                  v-on="on"
                  style="width: 192px"
                  ><v-icon color="primary" left>mdi-generator-portable</v-icon
                  ><span class="primary--text font-weight-bold"
                    >USAGE REPORT</span
                  ></v-btn
                >
              </template>
              <usage-form @close="usageDialog = false" />
            </v-dialog>
            <v-dialog
              v-model="energyReportDialog"
              width="100%"
              max-width="400"
              scrollable
              style="overflow-x: hidden"
            >
                  <!--moed to usage report view  -->
              <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :block="$vuetify.breakpoint.xsOnly"
                  color="secondary"
                  :disabled="!selectedTrailers?.length"
                  v-bind="attrs"
                  v-on="on"
                  class="mt-2"
                  style="width: 192px"
                  ><v-icon color="primary" left>mdi-chart-arc</v-icon
                  ><span class="primary--text font-weight-bold"
                    >ENERGY REPORT</span
                  ></v-btn
                >
              </template> -->
              <usage-form
                :isEnergyReport="true"
                @close="energyReportDialog = false"
              />
              <!-- <energy-report-form v-if="energyReportDialog" :companies="companies" :selectedTrailers="selectedTrailers" @close="energyReportDialog = false" /> -->
            </v-dialog>
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-sheet class="d-flex align-center justify-start transparent">
              <p
                class="text-body-1 text-uppercase secondary--text font-weight-bold mb-0"
              >
                DISPLAYED:
                {{
                  `${searchResults?.length ?? trailersDisplayed?.length ?? 0}/${
                    trailers?.length || 0
                  } ${
                    selectedTrailers?.length
                      ? "| SELECTED: " + selectedTrailers.length
                      : ""
                  }`
                }}
              </p>
              <v-tooltip v-if="hiddenSelectedTrailers > 0" color="warning" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs" color="warning" class="ml-2">
                    mdi-alert</v-icon
                  >
                </template>
                <span class="font-weight-bold"
                  >{{ hiddenSelectedTrailers }} selected
                  {{
                    hiddenSelectedTrailers === 1
                      ? "trailer is "
                      : "trailers are "
                  }}
                  not visible in search results.</span
                >
              </v-tooltip>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="trailers?.length" color="primary" class="mt-1 mb-16">
      <v-card-text>
        <v-data-table
          v-model="selectedTrailers"
          :headers="plantHeaders"
          :items="trailersDisplayed"
          :items-per-page="-1"
          item-key="id"
          :search="trailerSearch"
          show-select
          @current-items="searchResults = $event"
          class="elevation-1"
        >
          <template v-slot:header> </template>
          <template v-slot:top> </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style scoped>
>>> .v-dialog {
  overflow-x: hidden;
}

.filter-card {
  position: sticky;
  top: 55px;
  z-index: 11;
}

.home-container {
  max-width: 1400px;
}

/* >>> .v-list-item__action {
  display: none;
  visibility: hidden;
}

.v-list-item:hover >>> .v-list-item__action {
  display: flex;
  visibility: visible;
} */
</style>
